var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 109,
    viewBox: "0 0 100 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 73.5524L37.796 65L0 108.606H100L62.204 65L50 73.5524Z",
    fill: "#B22025"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 38.9078L50 0L100 38.9078H0Z",
    fill: "#EF5555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 38.9078H0V108.985H100V38.9078Z",
    fill: "#EF5555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 109L50 73.9466L0 38.9078V109Z",
    fill: "#E32726"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100 109L50 73.9466L100 38.9078V109Z",
    fill: "#E32726"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 38.9078L50 64.7833L100 38.9078L50 73.9466L0 38.9078Z",
    fill: "#BCBEC0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.abed06ae7fdc0964b51548cfd5094857.svg";
export { ForwardRef as ReactComponent };